<template>
  <!-- <div style="width: 1400px;margin: 20px auto;background-color: #fff;padding: 30px;" v-html="about_us"> -->
  <div style="width: 1200px; margin: 20px auto; align-items: normal;" >
    <div style="width: 1200px; height: 180px; background: #ffffff;padding-top: 60px;">


    <div style="width: 760px;
height: 66px;
border-radius: 5px;margin: 0 auto 0;border-right: none;" class="u-flex">
        <input v-model="name" type="text" style="flex:1;height: 66px;line-height: 66px;padding-left: 22px;border: 1px solid #2B73FF;outline: none;" placeholder="输入关键词，例如：人工智能">
        <el-button @click="search" type="primary" icon="el-icon-search" style="width:160px;height:66px">搜索</el-button>
    </div>


    </div>
     <div style="font-size:20px;margin:22px 0">推荐</div>
    <div class="u-flex" style="flex-wrap:wrap">
       <div class="u-flex-col item" style="margin-bottom:32px" v-for="(item,index) in list" :key="index" @click="towenzhang(item)">
        <img :src="item.show_image" alt="" sizes="" srcset="" style="width: 380px;
height: 218px;">
<div style="font-size: 16px;margin-top: 18px;text-align: center;">{{item.title}}</div>
       </div>
       
    </div>
    <div style="width: 240px;
height: 60px;line-height: 60px;
border: 1px solid #226EFF;margin: 20px auto 0;font-size: 20px;color: #226EFF;text-align: center;" v-show="total>list.length" @click="getMore">
        查看更多
       </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
		list:['关于我们','版权声明','隐私保护'],
      about_us: "",
	  copyright:'',
	  privacy:'',
	  current:0,
      list:[],
      name:'',
      page:1,
      total:0

    };
  },
  created() {
    this.getdata();
  },
  methods: {
    towenzhang(item){
				this.$router.push({
					path:"/bigDataInfo",
					query:{
						item:JSON.stringify(item)
					}
				})
			},
    getMore(){
        this.page++
        this.search()
    },
    search(){
        if(this.name==''){
            this.$message.error("请输入搜索内容")
            return
        }
        this.$http({
        url: "/api/Product/Articlelist",
        data:{
            name:this.name,
            page:this.page
        }
      }).then((res) => {
        this.total=res.data.count
        if(this.page==1){
            this.list = res.data.details;
        }else{
            this.list = [...this.list,...res.data.details];

        }
      });
    },
	itemClick(index){
		if(this.current!=index){
			this.current=index
		}
	},
    getdata() {
      this.$http({
        url: "/api/Product/productArticle",
      }).then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.item{
    margin-right: 30px;
}
.item:nth-child(3n){
    margin-right: 0;

}
.select{
	position: relative;
	
}
.select::before{
		content: '';
		position: absolute;
		top:50%;
		transform: translateY(-50%);
		left:0;
		width: 4px;
height: 34px;
background: #1C6AFF;
}

</style>
